var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInspUpload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7656 12.2366V19.2366C21.7656 19.767 21.5549 20.2757 21.1798 20.6508C20.8048 21.0259 20.2961 21.2366 19.7656 21.2366H5.76562C5.23519 21.2366 4.72648 21.0259 4.35141 20.6508C3.97634 20.2757 3.76563 19.767 3.76562 19.2366V5.23657C3.76562 4.70614 3.97634 4.19743 4.35141 3.82236C4.72648 3.44729 5.23519 3.23657 5.76562 3.23657H12.7656M16.7656 5.23657H22.7656M19.7656 2.23657V8.23657",
    stroke: "#9C4900",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.76562 11.2366C10.8702 11.2366 11.7656 10.3411 11.7656 9.23657C11.7656 8.132 10.8702 7.23657 9.76562 7.23657C8.66106 7.23657 7.76562 8.132 7.76562 9.23657C7.76562 10.3411 8.66106 11.2366 9.76562 11.2366Z",
    stroke: "#9C4900",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7656 15.2366L18.6796 12.1506C18.3046 11.7756 17.796 11.565 17.2656 11.565C16.7353 11.565 16.2267 11.7756 15.8516 12.1506L6.76562 21.2366",
    stroke: "#9C4900",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspUpload);
export default __webpack_public_path__ + "static/media/InspUpload.a3963f37f4a3616364685b0b133d6137.svg";
export { ForwardRef as ReactComponent };